query AnalyticsViewsByDate($filter: AnalyticsViewsFilterInput!, $calendarInterval: CalendarInterval) {
  analyticsViews(filter: $filter) {
    viewsByDate(calendarInterval: $calendarInterval) {
      calendarInterval
      items {
        label
        displayCurrency
        data {
          x
          y
        }
      }
    }
  }
}
